import { render, staticRenderFns } from "./CarNew.vue?vue&type=template&id=210bcd7f&"
import script from "./CarNew.vue?vue&type=script&lang=js&"
export * from "./CarNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports